import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DefaultLayout from 'layout/default/index';
import LanguageProvider from '../utils/LanguageProvider';
// import HomePage from "./pages/home"
import Storages from 'pages/Storages/index';
import StoragePage from 'pages/StoragePage/index';
import Devices from 'pages/Devices/index';
import Managers from '../pages/Managers';
import Customers from '../pages/Customers';
import Transactions from '../pages/Transactions';
import Profile from '../pages/Profile';
import Chat from '../pages/Chat';
import UserPairing from '../pages/UserPairing';

function RootRouter() {
  return (
    <DefaultLayout>
      <LanguageProvider>
        <Switch>
          <Route path="/devices" component={Devices} />
          <Route exact path="/storages" component={Storages} />
          <Route path="/storages/:id" component={StoragePage} />
          <Route path="/managers" component={Managers} />
          <Route path="/customers" component={Customers} />
          <Route path="/transactions" component={Transactions} />
          <Route path="/profile" component={Profile} />
          <Route path="/chat" component={Chat} />
          <Route path="/userpairing" component={UserPairing} />
        </Switch>
      </LanguageProvider>
    </DefaultLayout>
  );
}

export default RootRouter;
